/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VolumeMini,
    VolumeMiniFromJSON,
    VolumeMiniFromJSONTyped,
    VolumeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFileMini
 */
export interface MediaFileMini {
    /**
     * 
     * @type {number}
     * @memberof MediaFileMini
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MediaFileMini
     */
    readonly name: string;
    /**
     * 
     * @type {number}
     * @memberof MediaFileMini
     */
    readonly bundle?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MediaFileMini
     */
    readonly fullPath: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFileMini
     */
    customFields?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileMini
     */
    readonly isDir: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileMini
     */
    readonly isHardlink: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaFileMini
     */
    readonly mtime: number;
    /**
     * 
     * @type {number}
     * @memberof MediaFileMini
     */
    readonly parent?: number | null;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFileMini
     */
    readonly parentFile?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {string}
     * @memberof MediaFileMini
     */
    readonly path: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileMini
     */
    readonly present: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaFileMini
     */
    readonly size: number;
    /**
     * 
     * @type {VolumeMini}
     * @memberof MediaFileMini
     */
    volume: VolumeMini;
}

export function MediaFileMiniFromJSON(json: any): MediaFileMini {
    return MediaFileMiniFromJSONTyped(json, false);
}

export function MediaFileMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'bundle': !exists(json, 'bundle') ? undefined : json['bundle'],
        'fullPath': json['full_path'],
        'customFields': !exists(json, 'custom_fields') ? undefined : json['custom_fields'],
        'isDir': json['is_dir'],
        'isHardlink': json['is_hardlink'],
        'mtime': json['mtime'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'parentFile': !exists(json, 'parent_file') ? undefined : json['parent_file'],
        'path': json['path'],
        'present': json['present'],
        'size': json['size'],
        'volume': VolumeMiniFromJSON(json['volume']),
    };
}

export function MediaFileMiniToJSON(value?: MediaFileMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'custom_fields': value.customFields,
        'volume': VolumeMiniToJSON(value.volume),
    };
}


